<div class="container-fluid main-container">
    <form class="row" action="" [formGroup]="titleEdit">
        <div class="col-8">
            <div id="vimeo"></div>
            <div class="tag-container" id="tag-container">
                <div disabled class="checkbox-button" [ngClass]="{'checkbox-button-active': Animals}">
                    <input (change)="onChangeTag('Animals')" formControlName="Animals" class="tag-checkbox" id="animals"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="animals" id="animals-label" class="label-text">{{constants.ANIMALS_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': Rain}">
                    <input (change)="onChangeTag('Rain')" formControlName="Rain" class="tag-checkbox" id="rain"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="rain" id="rain-label" class="label-text">{{constants.RAIN_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': Snow}">
                    <input (change)="onChangeTag('Snow')" formControlName="Snow" class="tag-checkbox" id="snow"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="snow" id="snow-label" class="label-text">{{constants.SNOW_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': City}">
                    <input (change)="onChangeTag('City')" formControlName="City" class="tag-checkbox" id="city"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="city" id="city-label" class="label-text">{{constants.CITY_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': Nature}">
                    <input (change)="onChangeTag('Nature')" formControlName="Nature" class="tag-checkbox" id="nature"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="nature" id="nature-label" class="label-text">{{constants.NATURE_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': Night}">
                    <input (change)="onChangeTag('Night')" formControlName="Night" class="tag-checkbox" id="night"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="night" id="night-label" class="label-text">{{constants.NIGHT_TXT}}</label>
                </div>
                <div class="checkbox-button" [ngClass]="{'checkbox-button-active': DayVideo}">
                    <input (change)="onChangeTag('DayVideo')" formControlName="DayVideo" class="tag-checkbox" id="day"
                        type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="day" id="day-label" class="label-text">{{constants.DAY_TXT}}</label>
                </div>
                <div class="checkbox-button " [ngClass]="{'checkbox-button-active': Interiors}">
                    <input (change)="onChangeTag('Interiors')" formControlName="Interiors" class="tag-checkbox"
                        id="interior" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="interior" id="interior-label" class="label-text">{{constants.INTERIORS_TXT}}</label>
                </div>
                <div class="checkbox-button " [ngClass]="{'checkbox-button-active': Water}">
                    <input (change)="onChangeTag('Water')" formControlName="Water" class="tag-checkbox"
                        id="water" type="checkbox">
                    <img class="checkbox-img" [src]="constants.CHECKBOX_GREEN_IMG" alt="">
                    <img class="checkbox-close" [src]="constants.CLOSE_GREEN_IMG" alt="">
                    <label for="water" id="water-label" class="label-text">{{constants.WATER_TXT}}</label>
                </div>
            </div>
        </div>
        <div class="col-4" style="text-align: center;">
            <input formControlName="author" type="text" class="form-control form-space" placeholder="Author"
                value="{{data.author}}" aria-label="Author" aria-describedby="basic-addon2">
            <input formControlName="cityLocation" type="text" class="form-control" placeholder="City locaion"
                value="{{data.cityLocation}}" aria-label="Author" aria-describedby="basic-addon2">
            <button [disabled]="isLoading" (click)="onSubmit($event)" class="submit-button"
                [ngClass]="{'submit-button-success': success}">Submit</button>
        </div>
    </form>
</div>